import {useState} from 'react';
import {getPublicCBStandardsBySector} from 'api/certification-bodies';
import {alertByError} from 'utils/alerts';

function useGetCBStandardsSector(cbId, abId, sectorsId) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});

  async function getData(query) {
    setIsLoading(true);
    try {
      const {data, meta} = await getPublicCBStandardsBySector(cbId, {
        accreditation_bodies_id: abId,
        sectors_id: sectorsId,
        limit: 10,
        ...query,
      });

      setData(data);
      setMeta(meta);
    } catch (e) {
      alertByError(e);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    meta,
    data,
    isLoading,
    reload: getData,
  };
}

export default useGetCBStandardsSector;
